// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ProfileQuery$LiteracyplanetClientSxEntry from "./ProfileQuery.res.mjs";

function ProfileData(props) {
  var userId = props.userId;
  var isMe = props.isMe;
  var fetchProfile = ProfileQuery$LiteracyplanetClientSxEntry.use();
  var match = React.useState(function () {
        return "DisplayNone";
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          var current = {
            contents: true
          };
          var renderProfile = function (profile) {
            var state_0 = {
              TAG: "ProfileLoaded",
              _0: isMe,
              _1: profile
            };
            var state_1 = profile.user.userId;
            var state = {
              TAG: "Visible",
              _0: state_0,
              _1: state_1
            };
            setState(function (param) {
                  return state;
                });
          };
          var queryForCobraData = async function (userId) {
            var profile = await fetchProfile(userId);
            if (profile === undefined) {
              return ;
            }
            if (!(
                current.contents ? true : false
              )) {
              return ;
            }
            var tmp = profile.trophies;
            if (typeof tmp !== "object" && tmp === "TrophiesNotBuilt") {
              return renderProfile({
                          user: profile.user,
                          trophies: "TrophiesDisabled",
                          badges: profile.badges,
                          spBar: profile.spBar,
                          avatar: profile.avatar,
                          myUser: profile.myUser
                        });
            } else {
              return renderProfile(profile);
            }
          };
          if (userId !== undefined) {
            var state_0 = {
              TAG: "LoadingInitialData",
              _0: isMe
            };
            var state = {
              TAG: "Visible",
              _0: state_0,
              _1: userId
            };
            setState(function (param) {
                  return state;
                });
            queryForCobraData(userId);
          } else {
            setState(function (param) {
                  return "DisplayNone";
                });
          }
          return (function () {
                    current.contents = false;
                  });
        }), [userId]);
  if (typeof state !== "object") {
    return null;
  } else {
    return props.children(state._0);
  }
}

var make = ProfileData;

export {
  make ,
}
/* react Not a pure module */
